/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchDTOFromJSON, SearchDTOToJSON, } from './SearchDTO';
/**
 * Check if a given object implements the PaginatedResponseSearchDTO interface.
 */
export function instanceOfPaginatedResponseSearchDTO(value) {
    return true;
}
export function PaginatedResponseSearchDTOFromJSON(json) {
    return PaginatedResponseSearchDTOFromJSONTyped(json, false);
}
export function PaginatedResponseSearchDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'items': json['items'] == null ? undefined : (json['items'].map(SearchDTOFromJSON)),
    };
}
export function PaginatedResponseSearchDTOToJSON(json) {
    return PaginatedResponseSearchDTOToJSONTyped(json, false);
}
export function PaginatedResponseSearchDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'currentPage': value['currentPage'],
        'totalCount': value['totalCount'],
        'items': value['items'] == null ? undefined : (value['items'].map(SearchDTOToJSON)),
    };
}
